// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"58":"941dfae5","236":"e90e31f5","452":"b45c676e","482":"9f255201","489":"af2620c3","892":"69de2d06","908":"b111088b","971":"13298469","973":"98d3d4e5"}[chunkId] + ".chunk.js";
};